import Vue from "vue";
import { moduleFactory } from "@/store/resource";
import { unionBy } from "lodash";

const resourceModule = moduleFactory("online");

resourceModule.getters.userOnline = state => id => {
  return state.onlines.filter(online => online.id == id).length > 0;
};

resourceModule.getters.profileOnline = state => id => {
  return (
    state.onlines.filter(online => {
      return online.c == id;
    }).length > 0 ||
    Laravel.online.filter(onlineId => {
      return onlineId == id;
    }).length > 0
  );
};

resourceModule.mutations.updateOnline = state => {
  const unionResources = unionBy(
    state[`onlines`],
    state[`onlines`],
    resource => resource.id
  );
  Vue.set(state, `onlines`, unionResources);
};

resourceModule.getters.moderatorCountOnline = state => {
  return state.onlines.filter(online => {
    return online.m;
  }).length;
};

resourceModule.getters.userOnlineCount = state => ids => {
  return state.onlines.filter(online => {
    return ids.includes(online.id);
  }).length;
};

resourceModule.state.leavers = [];

resourceModule.mutations.addLeaver = (state, leaver) => {
  state.leavers.push(leaver);
};

resourceModule.mutations.removeLeaver = (state, leaver) => {
  let leaverIndex = state.leavers.indexOf(leaver);
  if (leaverIndex >= 0) {
    state.leavers.splice(leaverIndex, 1);
  }
};

resourceModule.getters.leavers = state => {
  return state.leavers;
};

export const onlineModule = resourceModule;
